import React from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuButton, MenuItem, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import PaymentIcon from '@mui/icons-material/Payment';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PersonIcon from '@mui/icons-material/Person';
import { FormattedMessage } from 'react-intl';

function AccountDropdown({ openBillingPortalDialog, openManageUsersDialog, hasBillingAccess }) {
  return (
    <div>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <MenuButton
            icon={<PersonIcon fontSize="medium" />}
            shape="circular"
            appearance="subtle"
            size="large"
            id="a3-account"
          />
        </MenuTrigger>
        <MenuPopover>
          <MenuItem
            onClick={openBillingPortalDialog}
            icon={<PaymentIcon fontSize="medium" />}
            disabled={!hasBillingAccess}
          >
            <FormattedMessage
              id="account.menu.item.billing"
              defaultMessage="Billing Portal"
              description="Menu Text"
            />
          </MenuItem>
          <MenuItem
            onClick={openManageUsersDialog}
            icon={<GroupAddIcon fontSize="small" />}
            disabled={!hasBillingAccess}
          >
            <FormattedMessage
              id="account.menu.item.manage"
              defaultMessage="Manage Users"
              description="Menu Text"
            />
          </MenuItem>
        </MenuPopover>
      </Menu>
    </div>
  );
}

AccountDropdown.propTypes = {
  openBillingPortalDialog: PropTypes.func.isRequired,
  openManageUsersDialog: PropTypes.func.isRequired,
  hasBillingAccess: PropTypes.bool.isRequired,
};

export default AccountDropdown;
